module.exports = __webpack_public_path__ + "static/media/018_IMG_0186.02544740.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/redboxinstant/018_IMG_0186.png
// module id = 626
// module chunks = 0